import { render, staticRenderFns } from "./collaboration.vue?vue&type=template&id=337fac79&scoped=true&"
import script from "./collaboration.vue?vue&type=script&lang=js&"
export * from "./collaboration.vue?vue&type=script&lang=js&"
import style0 from "./collaboration.vue?vue&type=style&index=0&id=337fac79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337fac79",
  null
  
)

export default component.exports